//service.js
import Router from 'vue-router';
import gql from 'graphql-tag'

const myService = function (Vue, options) {

  Vue.prototype.$service = {
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
    /**
       * 计算开始的时间在当前时间的描述  4分钟前 1小时前 ...
       * @param {Date} originDate 开始时间
       * @return {string} 该时间在当前时间的描述
       */
      SmartDate(originDate) {
        let nowDate = new Date(),
        isToday = false,
        isYesterday = false,
        isPastYear = false,
        isPreviousYear = false,
        originYear,
        originMonth,
        originDay,
        diffMinute,
        formatedDate;

        diffMinute = Math.round((nowDate.getTime() - originDate.getTime()) / (1000 * 60));

        originYear = originDate.getFullYear();
        originMonth = originDate.getMonth() + 1;
        originDay = originDate.getDate();

        if (diffMinute <= nowDate.getHours() * 60) {
        isToday = true;
        }
        if (nowDate.getDate() - originDay == 1) {
        isYesterday = true;
        }
        if (nowDate.getFullYear() - originYear == 1) {
        isPreviousYear = true;
        } else if (nowDate.getFullYear() - originYear > 1) {
        isPastYear = true;
        }
        if (diffMinute < 10 && isToday) {
        formatedDate = '刚刚';
        } else if (diffMinute < 60 && isToday) {
        formatedDate = `${diffMinute}分钟前`;
        } else if (diffMinute < 60 * 24 && isToday) {
        formatedDate = `${Math.floor(diffMinute / 60)}小时前`;
        } else if (diffMinute < 60 * 24 * 2 && isYesterday) {
        formatedDate = '1天前';
        } else if (diffMinute < 60 * 24 * 4) {
        formatedDate = '2天前';
        } else if (isPreviousYear) {
        formatedDate = '去年';
        } else if (isPastYear) {
        formatedDate = `${originYear}年`;
        } else {
        formatedDate = `${originMonth}月${originDay}日`;
        }
        return formatedDate;
    }, 
    replaceSpeace(txt) { //格式化简介
        if (!txt)return;
        let content = txt.replace(/\n/g,"<br/>");
        return content;
    }, 
    fnGetQueryString(key) { //正则获取url后面的参数值，如?env=dev&exp=123
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      var result = window.location.search.substr(1).match(reg);
      return result ? decodeURIComponent(result[2]) : false;
    },
    funcUrlDel(name, link = null) {
      //删除url指定参数名并返回新的url
      var loca = window.location;
      var baseUrl = loca.origin + loca.pathname + "?";
      var query = link ? link.split('?')[1] : loca.search.substr(1);
      if (query.indexOf(name) > -1) {
        var obj = {};
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=");
          obj[arr[i][0]] = arr[i][1];
        };
        delete obj[name];
        var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
        return url;
      } else {
        return link;
      }
    },
    refreshUrl() {
      //强制刷新到不带二次分享参数页面
      var url = "",
        reqStr = "";
      if (this.fnGetQueryString('from') || this.fnGetQueryString('isappinstalled')) {
        //from为微信二次分享自带参数
        url = this.funcUrlDel('from');
        url = this.funcUrlDel('isappinstalled', url);
        url = (url.search(/\?$/) !== -1) ? url.replace(/\?$/, ''): url;
        var reqIndex = url.indexOf('?');
        reqStr = url.substr(reqIndex);
        window.location.href = url;
      }
      if (location.href.search(/\?$/) !== -1) {
        window.location.href = location.href.replace(/\?$/, '');
      }
    },
  }
};

export default myService;
